import { Link, useLocation } from 'react-router-dom';

export function StickyReserveCta() {
  const location = useLocation();

  if (location.pathname === '/reserve') return null;

  return (
    <div className="tm-sticky-cta">
      <Link className="tm-btn tm-btn--solid" to="/reserve">
        예약하기
      </Link>
    </div>
  );
}
